module.exports = __webpack_public_path__ + "img/bgc6.9f55d450.png";